module.exports = function() {
  return new Worker(__webpack_public_path__ + "eb5462914ee5ec5914b0.worker.js");
};